<template>

    <!-- Loading App.vue -->
    <ModalLoading v-if="isLoading" :open="isLoading" />

    <div v-if="!isLoading" class="app-container">
        <NavBar />
        <RouterView />
        <footer-page />
    </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import NavBar from './components/Navbar/nav-bar.vue';
import footerPage from './components/Footer-Page/footer-page.vue';
import ModalLoading from './components/OrderShipmentData/ModalLoading/ModalLoading.vue';
import { nextTick, onMounted, ref } from 'vue';


const isLoading = ref<boolean>(true)

onMounted( async() => {
    
    await nextTick();


    setTimeout(() => {
       isLoading.value = false 
    }, 800);
    
})



</script>

<style scoped>

.app-container {
    opacity: 0;
    animation: fadeIn 0.3s ease-in forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

</style>